module.exports = __webpack_public_path__ + "media/images/icon-benefits-mental-c9656791b67374a4495591b8ae300e19.png";